<template>
  <div v-if="isLoggedIn">
    <h4>YOU CANNOT ACCESS THIS PAGE WHILE LOGGED IN. PLEASE LOG OUT AND RE-OPEN THE LINK TO ACCESS.</h4>
  </div>
  <div v-else class="content">
    <div class="reset-wrapper">
      <div class="reset">
        <PublicBrandHeader />
        <h3>Contact Verification</h3>
        <form id="contactform" @submit.prevent="handleVerifyContact">
          <div v-if="allFormErrors.length" class="form-error-summary" role="alert">
            <ul>
              <li v-for="(err, idx) in allFormErrors" :key="idx">{{ err }}</li>
            </ul>
          </div>
          <div class="mb-2">
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="firstname"
                  id="ContactFname"
                  required
                  class="form-control"
                  placeholder="Required"
                  v-model="form.first"
                />
                <label for="ContactFname" class="profile_label">First Name:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="lastname"
                  id="ContactLname"
                  class="form-control"
                  placeholder="Required"
                  required
                  v-model="form.last"
                />
                <label for="ContactLname" class="profile_label">Last Name:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="email"
                  name="contactEmail"
                  id="ContactEmail"
                  required
                  placeholder="Required"
                  class="form-control"
                  v-model="form.email"
                  @keyup="validateEmail"
                />
                <label for="ContactEmail" class="profile_label">Email:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="username"
                  id="ContactUsername"
                  class="form-control"
                  placeholder="Required"
                  required
                  v-model="form.login"
                  @keyup="validateUsername"
                />
                <label for="ContactUsername" class="profile_label">Username:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="password"
                  name="password"
                  id="ContactPw"
                  required
                  placeholder="Enter password"
                  class="form-control"
                  v-model="form.password"
                  @change="validatePassword"
                />
                <label for="ContactPw" class="profile_label">Password:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="password"
                  name="passwordConfirm"
                  id="ContactPwConfirm"
                  required
                  placeholder="Confirm password"
                  class="form-control"
                  v-model="form.password2"
                  @change="confirmPassword"
                />
                <label for="ContactPwConfirm" class="profile_label">Confirm Password:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="date"
                  name="dob"
                  id="ContactDob"
                  required
                  class="form-control"
                  v-model="form.dob"
                />
                <label for="ContactDob" class="profile_label">Date of Birth:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  name="gender"
                  id="ContactGender"
                  required
                  class="form-control"
                  v-model="form.gender"
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                  <option value="Prefer not to say">Prefer not to say</option>
                </select>
                <label for="ContactGender" class="profile_label">Gender:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="phone"
                  id="ContactPhone"
                  placeholder="Phone Number"
                  class="form-control"
                  v-model="form.primaryPhone"
                />
                <label for="ContactPhone" class="profile_label">Phone Number:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="address"
                  id="ContactAddress"
                  placeholder="Address"
                  class="form-control"
                  v-model="form.addr"
                />
                <label for="ContactAddress" class="profile_label">Address:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="city"
                  id="ContactCity"
                  placeholder="City"
                  class="form-control"
                  v-model="form.city"
                />
                <label for="ContactCity" class="profile_label">City:</label>
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  name="state"
                  id="ContactState"
                  class="form-control"
                  v-model="form.state"
                >
                  <option value="">Select State</option>
                  <option v-for="state in states" :key="state.id" :value="state.abbr">
                    {{ state.value }}
                  </option>
                </select>
                <label for="ContactState" class="profile_label">State:</label>
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="zip"
                  id="ContactZip"
                  placeholder="ZIP Code"
                  class="form-control"
                  v-model="form.zip"
                />
                <label for="ContactZip" class="profile_label">ZIP Code:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  name="relationType"
                  id="ContactRelation"
                  required
                  class="form-control"
                  v-model="form.relationType"
                >
                  <option value="">Select Relationship</option>
                  <option value="Brother">Brother</option>
                  <option value="Daughter">Daughter</option>
                  <option value="Daughter in law">Daughter in law</option>
                  <option value="Emergency Contact">Emergency Contact</option>
                  <option value="Father">Father</option>
                  <option value="Guardian">Guardian</option>
                  <option value="Mother">Mother</option>
                  <option value="Sister">Sister</option>
                  <option value="Son">Son</option>
                  <option value="Son in law">Son in law</option>
                  <option value="Spouse">Spouse</option>
                </select>
                <label for="ContactRelation" class="profile_label">Relationship:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  name="communicationPreference"
                  id="ContactCommPref"
                  class="form-control"
                  v-model="form.communicationPreference"
                >
                  <option value="Email">Email</option>
                  <option value="Phone">Phone</option>
                  <option value="Text">Text</option>
                </select>
                <label for="ContactCommPref" class="profile_label">Communication Preference:</label>
              </div>
            </div>
          </div>
          <div class="mb-2">
            <button type="submit" class="btn btn-primary w-100">
              Complete Registration
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { register, isUserExist, isEmailExist } from "@/api/userApi";
import { CURR_API } from "@/constants/apis";
import axios from "axios";
import router from "@/router/index";
import store from "@/store";
import us from "us";
import { LoginNavigation } from "@/store/modules/fsm/messages";
import VALIDATION_ERRORS from "@/data/validationErrors";
import { getPasswordPolicyErrors } from "@/utils/passwordPolicy";
import PublicBrandHeader from '@/components/public-layouts/PublicBrandHeader.vue';

export default {
  name: 'verify-contact',
  components: {
    PublicBrandHeader,
  },
  props: {
    invitation: { type: String, default: "" },
    firstName: { type: String, default: "" },
    lastName: { type: String, default: "" },
    email: { type: String, default: "" },
    relationType: { type: String, default: "" },
    inviterAccountNumber: { type: String, default: "" },
    inviterName: { type: String, default: "" }
  },
  data() {
    return {
      domRoot: document.getElementById('app'),
      states: us.states,
      form: {
        first: "",
        last: "",
        email: "",
        login: "",
        password: "",
        password2: "",
        dob: "",
        gender: "",
        primaryPhone: "",
        addr: "",
        city: "",
        state: "",
        zip: "",
        relationType: "",
        communicationPreference: "Email",
        accountType: "Patient",
        admin: false,
        isLoggedIn: false,
        externid2: null
      },
      formErrors: {
        first: [],
        last: [],
        email: [],
        login: [],
        password: [],
        password2: [],
        dob: [],
        gender: [],
        relationType: []
      },
      invitationData: null
    }
  },
  computed: {
    isLoggedIn: function () {
      let isLoggedIn = store.getters["login/isLoggedIn"];
      return isLoggedIn;
    },
    /** Flattens formErrors into one list for the top-of-form error summary. */
    allFormErrors() {
      const out = [];
      for (const key in this.formErrors) {
        const fieldErrors = this.formErrors[key];
        if (Array.isArray(fieldErrors)) {
          for (const msg of fieldErrors) {
            if (msg) out.push(msg);
          }
        }
      }
      return out;
    },
  },
  beforeCreate() {
    // Access store directly since computed properties aren't available in beforeCreate
    let isLoggedIn = store.getters["login/isLoggedIn"];
    if (isLoggedIn) {
      alert("Please logout to verify account");
      router.push({ name: LoginNavigation });
    }
    let isInit = this.$gotInitialMessage();
    if (!isInit) {
      let href = location.href + "";
      setTimeout(() => location.assign(href), 5000);
    }
  },
  created() {
    for (let key in this.form) {
      this.formErrors[key] = []
    }
    this.handleInvitationToken();
  },
  mounted() {
    // Show invitation banner after component is mounted to avoid SweetAlert init timing issues
    if (this.invitationData) {
      const text = `${this.invitationData.inviterName || 'A team member'} has invited you to join their healthcare team as a ${this.invitationData.relationType || 'contact'}. Please complete the form below to create your account.`;
      if (this.$swal && this.$swal.fire) {
        this.$swal.fire({ title: "You've been invited!", text, icon: 'info', confirmButtonText: 'Got it!' });
      } else if (typeof this.$swal === 'function') {
        this.$swal({ title: "You've been invited!", text, type: 'info', confirmButtonText: 'Got it!' });
      } else if (window && window.Swal && window.Swal.fire) {
        window.Swal.fire({ title: "You've been invited!", text, icon: 'info', confirmButtonText: 'Got it!' });
      }
    }
  },
  methods: {
    validateUsername() {
      const usernameRegex = new RegExp("^([a-zA-Z]|_)+([a-zA-Z0-9_])*$");
      let error = null;

      this.form.login = this.form.login.trim();
      this.formErrors.login = [];
      
      if (!usernameRegex.test(this.form.login)) {
        error = VALIDATION_ERRORS.USERNAME_CHARACTERS;
        this.formErrors.login[this.formErrors.login.length] = error;
      }
      if (!(this.form.login.length >= 8 && this.form.login.length <= 24)) {
        error = VALIDATION_ERRORS.USERNAME_LENGTH;
        this.formErrors.login[this.formErrors.login.length] = error;
      }
      if (this.formErrors.login.length < 1) {
        isUserExist(this.form.login)
          .then((userExists) => {
            // Assign (don't push) so overlapping isUserExist replies can't stack the same message.
            this.formErrors.login = userExists ? [VALIDATION_ERRORS.USERNAME_EXISTS] : [];
          })
          .catch((err) => {
            alert(err);
          });
      }
    },
    validateEmail() {
      let error = null;
      isEmailExist(this.form.email)
        .then((exists) => {
          if (exists) {
            error = VALIDATION_ERRORS.EMAIL_EXISTS;
            this.formErrors.email[this.formErrors.email.length] = error;
          } else {
            this.formErrors.email = [];
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    handleInvitationToken() {
      // Use props directly instead of parsing route query
      const invitationToken = this.invitation;
      
      if (invitationToken) {
        // Use props directly
        const firstName = this.firstName;
        const lastName = this.lastName;
        const email = this.email;
        const relationType = this.relationType;
        const inviterAccountNumber = this.inviterAccountNumber;
        const inviterName = this.inviterName;
        
        // Pre-fill form with invitation data
        if (firstName) this.form.first = firstName;
        if (lastName) this.form.last = lastName;
        if (email) this.form.email = email;
        if (relationType) this.form.relationType = relationType;
        
        // Set account type and inviter link
        this.form.accountType = 'Patient';
        this.form.externid2 = inviterAccountNumber ? inviterAccountNumber : null;
        
        // Store invitation data
        this.invitationData = {
          token: invitationToken,
          firstName: firstName || '',
          lastName: lastName || '',
          email: email || '',
          relationType: relationType || '',
          inviterAccountNumber: inviterAccountNumber || null,
          inviterName: inviterName || ''
        };
        
        // Defer showing any modal until mounted() to avoid SweetAlert constructor issues
      } else {
        // No invitation token, redirect to login
        router.push({ name: LoginNavigation });
        alert("Invalid invitation link. Please request a new one.");
      }
    },
    validatePassword() {
      this.formErrors.password = getPasswordPolicyErrors(this.form.password, [
        this.form.first,
        this.form.middle,
        this.form.last,
      ]);
    },
    confirmPassword() {
      this.formErrors.password2 = [];
      if (this.form.password !== this.form.password2) {
        this.formErrors.password2.push("Passwords must match exactly");
      }
    },
    validateForm() {
      let isValid = true;
      
      // Clear previous errors
      for (let key in this.formErrors) {
        this.formErrors[key] = [];
      }
      
      // Validate required fields
      if (!this.form.first.trim()) {
        this.formErrors.first.push("First name is required");
        isValid = false;
      }
      
      if (!this.form.last.trim()) {
        this.formErrors.last.push("Last name is required");
        isValid = false;
      }
      
      if (!this.form.email.trim()) {
        this.formErrors.email.push("Email is required");
        isValid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
        this.formErrors.email.push("Please enter a valid email address");
        isValid = false;
      }
      
      if (!this.form.login.trim()) {
        this.formErrors.login.push("Username is required");
        isValid = false;
      } else if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(this.form.login)) {
        this.formErrors.login.push("Username can only contain alpha-numeric characters or underscore (_), and must begin with a letter or an underscore");
        isValid = false;
      }
      
      if (!this.form.password) {
        this.formErrors.password.push("Password is required");
        isValid = false;
      }
      
      if (!this.form.password2) {
        this.formErrors.password2.push("Password confirmation is required");
        isValid = false;
      }
      
      if (!this.form.dob) {
        this.formErrors.dob.push("Date of Birth is required");
        isValid = false;
      }
      
      if (!this.form.gender) {
        this.formErrors.gender.push("Gender is required");
        isValid = false;
      }
      
      if (!this.form.relationType) {
        this.formErrors.relationType.push("Relationship is required");
        isValid = false;
      }
      
      // Validate password match
      if (this.form.password !== this.form.password2) {
        this.formErrors.password2.push("Passwords must match exactly");
        isValid = false;
      }
      
      return isValid;
    },
    async handleVerifyContact() {
      if (!this.validateForm()) {
        this.$swal({
          title: "Please fix the errors below",
          text: "Some required fields are missing or invalid.",
          icon: "error"
        });
        return;
      }
      
      try {
        // Show loading
        const loader = this.$loading.show({
          container: this.domRoot,
        }, {
          after: this.$createElement('div', {}, 'Creating account...')
        });
        
        // Set form data
        this.form.isLoggedIn = false;
        this.form.admin = false;
        
        // Create account using register function
        const response = await register(this.form);
        
        loader.hide();
        
        if (response.externid && response.externid !== "") {
          this.$swal({
            title: "Account Created Successfully!",
            text: "Your account has been created and you can now log in.",
            icon: "success",
            confirmButtonText: "Go to Login"
          }).then(() => {
            router.push({ name: LoginNavigation });
          });
        } else {
          this.$swal({
            title: "Error",
            text: "There was an error creating your account. Please try again.",
            icon: "error"
          });
        }
        
      } catch (error) {
        console.error('Error creating account:', error);
        this.$swal({
          title: "Error",
          text: "There was an error creating your account. Please try again.",
          icon: "error"
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../stylesheets/mixins/alignment";
$color-base: #0060ff;
.btn--login {
  color: #fff;
  background-color: $color-base;

  &:hover {
    background-color: lighten($color-base, 5%);
  }
}
.return__link {
  float: right;
  background-color: $color-base;
}
.form__link {
  color: white;
  text-decoration: none;
}
#sbmtuserbtn {
  border-radius: 0.375em;
}
.button-group {
  /*margin-top: 1.5rem;*/

  .form__link {
    color: $color-base;
    font-size: 0.85rem;
    margin-top: 0.5rem;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
}
.content {
  width: 100%;
  height: auto;
  background: url("../../assets/images/bg.jpg") no-repeat center fixed; // TODO image subject to copyright
  background-size: cover;
  position: relative;
}
.reset-wrapper {
  height: 100vh;
  width: 100%;
  position: relative;
}

.reset {
  width: 60% !important;
  background-color: #fff;
  padding: 2rem;
  -moz-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);

  @include absoluteCenter(380px);

  > h3 {
    text-align: center;
  }
}
.reset__introduction {
  color: darken(gray, 10%);
  font-size: 14px;
  text-align: center;
}
.btn--reset {
  color: #fff;
  background-color: $color-base;
  &:hover {
    background-color: lighten($color-base, 5%);
  }
}

.button-group {
  margin-top: 1.5rem;

  .form__link {
    color: $color-base;
    font-size: 0.85rem;
    margin-top: 0.5rem;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
}

.form__input {
  font-size: 0.85rem;
}
.col-form-label {
  font-size: 14px;
  width: 100%;
}

@media only screen and (max-width: 768px) {
  .reset {
    width: 90% !important;
    height: 90%;
    overflow: auto;
  }
}

.file_link {
  font-weight: bold;
}

.form-error-summary {
  margin: 0.75rem 0 1.5rem;
  padding: 0.9rem 1.15rem;
  background: #fdecea;
  border: 1px solid #f3b4b0;
  border-radius: 6px;
}

.form-error-summary ul {
  margin: 0;
  padding-left: 1.1rem;
  color: #9b2c2c;
}

.form-error-summary li {
  margin: 0.15rem 0;
}
</style>
